import React from "react";
import Skeleton from "react-loading-skeleton";
import clsx from "clsx";
import { styles } from "./styles";

interface SummaryRowProps {
  icon?: React.ReactNode;
  title: string;
  amount: string | number | null | undefined;
  currency: string;
  loading?: boolean;
  children?: React.ReactNode;
}

const SummaryRow: React.FC<SummaryRowProps> = ({
  icon,
  title,
  amount,
  currency,
  loading,
  children,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.inner}>
        <div className={styles.row}>
          <div className={styles.left}>
            {icon && <div className={styles.iconWrapper}>{icon}</div>}
            {title}
            {children}
          </div>

          {loading ? (
            <Skeleton width={100} height="100%" />
          ) : (
            <div
              className={clsx(
                styles.right,
                title === "They Receive" ? "-mr-[0.65rem]" : "-mr-[0.20rem]"
              )}
            >
              <div className={styles.amount}>{amount}</div>
              <div className={styles.currency}>{currency}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SummaryRow;
